// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/main.css'
import store from './store/index'
import $ from 'jquery'
import http from './utils/http'
import wx from 'weixin-js-sdk'
import MetaInfo from 'vue-meta-info'
import VueClipboard from 'vue-clipboard2'
import point from './point/point'
import Vconsole from 'vconsole';
import Router from 'vue-router'
import * as types from "@/store/types";
import VueCookies from 'vue-cookies'
import layer from 'vue-layer'
import promise from 'es6-promise';
promise.polyfill();

import vueMiniPlayer from 'vue-mini-player'
Vue.use(vueMiniPlayer)

import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video



Vue.prototype.$layer = layer(Vue);

// new Vconsole();

Vue.prototype.$point = point
Vue.config.productionTip = false

Vue.use(http)
Vue.use(MetaInfo)
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(VueCookies)


const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

//路由拦截
router.beforeEach((to, from, next) => {

  if (to.path.indexOf("/agree") < 0 && to.path.indexOf("/app") < 0 && to.path.indexOf("/index") < 0 
  && to.path.indexOf("/channel") < 0 && to.path.indexOf("share") < 0 && to.path.indexOf("/userAppInfo") < 0 
  && to.path.indexOf("/qmlResult") < 0  && to.path.indexOf("/iosSetting") < 0
  && to.path.indexOf("/chanelResultDown") < 0 &&  to.path.indexOf("/chanelResult") < 0  &&  to.path.indexOf("/contactKF")  < 0  
  &&  to.path.indexOf("/showvip")  < 0    &&  to.path.indexOf("/question") < 0       &&  to.path.indexOf("/noviceguide")   < 0  
  ) {
    var tokenTime = localStorage.getItem("tokenTime");
    if (tokenTime == null || tokenTime == undefined) {
      localStorage.setItem("tokenTime", new Date());
    }
    var nowTime = new Date();
    var times = new Date(tokenTime);
    var diff = parseInt(nowTime - times) / 1000 / 60
    console.log("tokentime:" + JSON.stringify(times) + " diff:" + diff)
    localStorage.setItem("tokenTime", new Date());
    if (diff > 10) {
      if (to.path !== '/login') {
        store.commit(types.SET_USERINFO, null);
        store.commit(types.SET_USERLIST, null);
        store.commit(types.LOGIN, null);
        store.commit(types.SET_LOGIN_OBJ, null);
        localStorage.removeItem('token');
        return next('/login')
      }
    }
  }
  //对index单独处理
  if (to.path.indexOf("/index") >= 0) {
    //判断是否有token
    var token = localStorage.getItem("token");
    if (token) {
      var tokenTime = localStorage.getItem("tokenTime");
      if (tokenTime == null || tokenTime == undefined) {
        localStorage.setItem("tokenTime", new Date());
      }
      var nowTime = new Date();
      var times = new Date(tokenTime);
      var diff = parseInt(nowTime - times) / 1000 / 60
      console.log("tokentime:" + JSON.stringify(times) + " diff:" + diff)
      localStorage.setItem("tokenTime", new Date());
      if (diff > 10) {
        //退出逻辑
        store.commit(types.SET_USERINFO, null);
        store.commit(types.SET_USERLIST, null);
        store.commit(types.LOGIN, null);
        store.commit(types.SET_LOGIN_OBJ, null);
        localStorage.removeItem('token');

      }
    }
  }
  localStorage.setItem("tokenTime", new Date());
  next()
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // 引入store
  store: store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js